
export class WorkerInfo {
    contact_person_name: string;
    contact_person_phone_no: string;
    hourly_rate: number;
    seller_company_name: string;
    seller_id: number;
    seller_user_id: number;
    user_id: number;
    worker_designation: string;
    worker_email: string;
    worker_id: number;
    worker_name: string;
    worker_phone_no: string;
    worker_type_id: number;
    worker_type_name: string;
    image_url: string;
}



// WEBPACK FOOTER //
// ./src/app/worker/worker.ts